export const setRedirect = (payload) => (dispatch) => {
	dispatch({ type: 'SET_REDIRECT', payload });
	return true;
};
export const removeRedirect = (payload) => (dispatch) => {
	dispatch({ type: 'REMOVE_REDIRECT' });
	return true;
};
